import gql from 'graphql-tag'

const fragments = {
  address: gql`
    fragment Address on AddressNode {
      id
      addressType
      addressValue
      default
      inactive
      optedOut
      verified
    }
  `,
  bankAccount: gql`
    fragment BankAccount on BankAccountNode {
      id
      bankName
      beneficiaryName
      accountNumber
      accountType
      branchCode
      verified
    }
  `,
  identityBankAccount: gql`
    fragment IdentityBankAccount on IdentityBankAccountNode {
      id
      default
      status
      statusReason
      ownership
      verifiedAt
      bankaccount {
        id
        bankName
        beneficiaryName
        accountNumber
        accountType
        branchCode
      }
      identity {
        id
        fullName
      }
      workflowrunVerification {
        id
      }
    }
  `,
  case: gql`
    fragment Case on CaseNode {
      id
      priority
      productType
      requestType
      status
      nextActionAt
      resolvedAt
      reviewedAt
      updatedAt
      assignedTo {
        id
        firstName
        lastName
      }
      casenotes {
        edges {
          node {
            id
            note
            createdAt
            author {
              id
              firstName
              lastName
            }
          }
        }
      }
      affects {
        id
        client {
          id
          identity {
            id
          }
          division {
            id
            name
            employer {
              id
              friendlyName
            }
          }
        }
        contacts {
          edges {
            node {
              id
              identity {
                id
              }
              division {
                id
                name
                employer {
                  id
                  friendlyName
                }
              }
            }
          }
        }
      }
    }
  `,
  caseClient: gql`
    fragment CaseClient on CaseNode {
      id
      status
      productType
      affects {
        id
        client {
          id
          identity {
            id
          }
          division {
            id
            name
            employer {
              id
              friendlyName
            }
          }
        }
        contacts {
          edges {
            node {
              id
              identity {
                id
              }
              division {
                id
                name
                employer {
                  id
                  friendlyName
                }
              }
            }
          }
        }
      }
    }
  `,
  caseInformation: gql`
    fragment CaseInformation on CaseNode {
      id
      priority
      productType
      requestType
      status
      createdAt
      nextActionAt
      resolvedAt
      reviewedAt
      updatedAt
      affects {
        id
        firstName
        lastName
      }
      assignedTo {
        id
        firstName
        lastName
      }
      createdBy {
        id
        identity {
          id
          firstName
          lastName
        }
      }
    }
  `,
  casenote: gql`
    fragment CaseNote on CaseNoteNode {
      id
      note
      case {
        id
        assignedTo {
          id
          firstName
          lastName
        }
        openedAt
        openedBy {
          id
          firstName
          lastName
        }
      }
      createdAt
      author {
        id
        firstName
        lastName
        otherName
      }
    }
  `,
  client: gql`
    fragment Client on ClientNode {
      id
      employmentType
      employeeNumber
      finworksId
      salary
      status
      statusReason
      employmentCommencedAt
      notes
      division {
        id
      }
      payrollcycle {
        id
      }
    }
  `,
  clientAddresses: gql`
    fragment ClientAddresses on ClientNode {
      id
      identity {
        id
        defaultAddressType
        addresses {
          edges {
            node {
              id
              addressType
              addressValue
              default
              inactive
              optedOut
            }
          }
        }
      }
    }
  `,
  clientEmployment: gql`
    fragment ClientEmployment on ClientNode {
      id
      employmentType
      employeeNumber
      salary
      status
      statusReason
      division {
        id
        name
        notes
        employer {
          id
          friendlyName
          identity {
            id
            membershipStatus
          }
          payrollcycles {
            edges {
              node {
                id
                cycle
                name
              }
            }
          }
        }
      }
    }
  `,
  clientFuneralPolicy: gql`
    fragment ClientFuneralPolicy on ClientFuneralPolicyNode {
      id
      benefits {
        edges {
          node {
            id
            paidBy
            relationship
            funeralbenefit {
              id
              benefitType
              benefitCost
              benefitAmount
              coverProvider
              contributionType
              description
            }
            appliesTo {
              id
              firstName
              lastName
              identityValue
              dateOfBirth
            }
          }
        }
      }
    }
  `,
  clientIdentity: gql`
    fragment ClientIdentity on ClientNode {
      id
      identity {
        id
      }
    }
  `,
  clientInformation: gql`
    fragment ClientInformation on ClientNode {
      id
      identity {
        id
        firstName
        lastName
        otherName
        language
        dateOfBirth
        deceased
        membershipStatus
        identityType
        identityValue
      }
    }
  `,
  contact: gql`
    fragment Contact on ContactNode {
      id
      identity {
        id
        firstName
        lastName
        communicateThrough {
          id
          firstName
          lastName
        }
        defaultAddressType
        addresses {
          edges {
            node {
              id
              addressType
              addressValue
              inactive
              default
              optedOut
            }
          }
        }
      }
      role
      position
      employer {
        id
        friendlyName
        divisions {
          edges {
            node {
              id
              name
            }
          }
        }
        payrollcycles {
          edges {
            node {
              id
              name
              cycle
            }
          }
        }
      }
      division {
        id
        name
      }
      payrollcycle {
        id
        name
        cycle
      }
      notes
    }
  `,
  contactSummary: gql`
    fragment ContactSummary on ContactNode {
      id
      identity {
        id
        firstName
        lastName
      }
      role
      position
      employer {
        id
        friendlyName
      }
      division {
        id
        name
      }
      payrollcycle {
        id
        name
        cycle
      }
    }
  `,
  credit: gql`
    fragment Credit on CreditNode {
      id
      creditType
      amount
      balance
      cmsId
      cmsStatus
      instalmentCurrent
      instalmentAgreed
      finalInstalmentAt
      repayableCurrent
      longtermMonthlyContributionRequired
      repaid
      createdAt
      refreshedAt
      activatedBy {
        id
        firstName
        lastName
      }
      client {
        id
        identity {
          id
          firstName
          lastName
        }
      }
      issuedBy {
        id
        firstName
        lastName
      }
      creditapplication {
        id
      }
      workflowrunProcessing {
        id
      }
    }
  `,
  creditApplication: gql`
    fragment CreditApplication on CreditApplicationNode {
      id
      calltime
      creditType
      amountAppliedFor
      amountEligibleFor
      amountAppliedForEligible
      eligibleLoanAmount
      calculations
      calculationsCamelcase
      outcome
      outcomeAt
      outcomeNotes
      approverNotes
      issuedAt
      issuerNotes
      overrideNotes
      status
      overrideAt
      finalisedAt
      approvedAt
      updatedAt
      locked
      picsaScore
      earnbacksBalance
      balanceLongtermInvestedIncl
      investmentLongClientMonthlyContribution
      overrideStatus
      overrideEligibleLoanAmount
      assignedTo {
        id
        firstName
        lastName
      }
      approvedBy {
        id
        firstName
        lastName
      }
      createdBy {
        id
        firstName
        lastName
        identity {
          id
        }
      }
      finalisedBy {
        id
        firstName
        lastName
      }
      issuedBy {
        id
        fullName
      }
      overrideBy {
        id
        firstName
        lastName
      }
      updatedBy {
        id
        identity {
          id
          fullName
        }
      }
      bankaccount {
        id
        bankName
        accountNumber
        accountType
        branchCode
      }
      client {
        id
        division {
          id
          employer {
            id
            creditMultiplier
          }
        }
        employmentType
        employmentCommencedAt
        latestInvestmentValue
        salary
        salaryMonthly
        identity {
          id
          earnbacksMembershipLength
          earnbacksStatus
          firstName
          healthLevelHistory
          lastName
          identityValue
          identityType
          membershipStatus
          picsaMembershipLength
          picsaScore
          earnbacksBalance
          balanceShorttermInvestedIncl
          balanceLongtermInvestedIncl
          investmentShortClientMonthlyContribution
          investmentLongClientMonthlyContribution
          investmentLongClientCycleContribution
          addresses(addressType: "msisdn", default: true, inactive: false) {
            edges {
              node {
                id
                addressValue
              }
            }
          }
          communicateThrough {
            id
          }
          identitybankaccounts {
            edges {
              node {
                id
                default
                bankaccount {
                  bankName
                  accountNumber
                  accountType
                  branchCode
                }
              }
            }
          }
        }
        payrollcycle {
          id
          cycle
        }
        saving {
          id
          clientContribution
        }
        loans(lmsStatus: "active") {
          edges {
            node {
              id
              amount
              balance
              loanType
              lmsStatus
              instalmentCurrent
              createdAt
              client {
                identity {
                  id
                }
              }
            }
          }
        }
        credits(cmsStatus: "active") {
          edges {
            node {
              id
              amount
              balance
              creditType
              cmsStatus
              instalmentCurrent
              longtermMonthlyContributionRequired
              createdAt
              client {
                identity {
                  id
                }
              }
            }
          }
        }
      }
      consolidations {
        edges {
          node {
            id
            amount
            statementExpiresAt
            creditreportaccount {
              id
              creditreportsupplier {
                id
                name
              }
              balance
              openBalance
            }
          }
        }
      }
      creditreport {
        id
        enquiryId
        purpose
        createdAt
        accounts {
          edges {
            node {
              id
              creditreportsupplier {
                id
                name
              }
              balance
              openBalance
              paymentFreqDesc
              instalment
              overdue
              consolidation {
                edges {
                  node {
                    id
                    amount
                    statementExpiresAt
                    bankaccountRef
                    approvedBy {
                      id
                    }
                    creditreportaccount {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      expenses {
        edges {
          node {
            id
            label
            amount
          }
        }
      }
      selectablePayslips {
        id
      }
      selectedPayslips {
        id
        totalGross
      }
      missingPayslipDates
      credits {
        edges {
          node {
            id
            creditType
            amount
            balance
            instalmentCurrent
            instalmentAgreed
            longtermMonthlyContributionRequired
            cmsId
            createdAt
            refreshedAt
            activatedBy {
              id
              firstName
              lastName
            }
            workflowrunProcessing {
              id
              status
              atStep
              createdBy {
                id
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  `,
  creditApplicationListing: gql`
    fragment CreditApplicationListing on CreditApplicationNode {
      id
      status
      creditType
      client {
        id
        identity {
          id
          firstName
          lastName
        }
      }
      amountAppliedFor
      createdAt
      assignedTo {
        id
        firstName
        lastName
      }
    }
  `,
  division: gql`
    fragment Division on DivisionNode {
      id
      name
      notes
    }
  `,
  divisionClients: gql`
    fragment DivisionClients on DivisionNode {
      id
      clients {
        edges {
          node {
            id
            identity {
              id
              firstName
              lastName
              otherName
            }
          }
        }
      }
    }
  `,
  divisionInformation: gql`
    fragment DivisionInformation on DivisionNode {
      id
      name
      notes
    }
  `,
  email: gql`
    fragment Email on EmailNode {
      id
      subject
      textBody
      htmlBody
      toAddrs
      fromAddr
      direction
      createdAt
      scheduledAt
      status
      emailType
      attachments {
        id
        asset
        url
        parent {
          id
          asset
          url
        }
        children {
          edges {
            node {
              id
              asset
              url
            }
          }
        }
      }
      fromIdentity {
        id
        fullName
        client {
          id
        }
      }
      toIdentities {
        id
        fullName
      }
    }
  `,
  emailRelation: gql`
    fragment EmailRelation on EmailRelationNode {
      id
      objectId
      email {
        id
      }
      contentType {
        id
      }
    }
  `,
  employerFuneralPolicy: gql`
    fragment EmployerFuneralPolicy on EmployerFuneralPolicyNode {
      id
      funeralbenefits {
        id
        benefitType
        benefitCost
        benefitAmount
        coverProvider
        contributionType
        description
        entryAgeMin
        entryAgeMax
      }
      funeralpolicy {
        id
        coverProvider
        contributionType
        description
      }
    }
  `,
  employerInformation: gql`
    fragment EmployerInformation on EmployerNode {
      id
      friendlyName
      notes
      identity {
        id
        firstName
        lastName
      }
    }
  `,
  event: gql`
    fragment Event on EventNode {
      id
      sourceModel
      sourceId
      eventAt
      eventType
      eventData
      createdAt
    }
  `,
  file: gql`
    fragment File on FileNode {
      id
      asset
      url
      processed
      filetype {
        id
        name
      }
      parent {
        id
        asset
        url
      }
      children {
        edges {
          node {
            id
            asset
            url
          }
        }
      }
    }
  `,
  fileRelation: gql`
    fragment FileRelation on FileRelationNode {
      id
      file {
        id
        asset
        url
      }
      objectId
    }
  `,
  identity: gql`
    fragment Identity on IdentityNode {
      id
      firstName
      lastName
      otherName
      language
      dateOfBirth
      deceased
      membershipStatus
      identityType
      identityValue
      earnbacksStatus
      earnbacksType
      membershipStatus
      membershipType
      productsStatus
    }
  `,
  identitySummary: gql`
    fragment IdentitySummary on IdentityNode {
      id
      firstName
      lastName
      otherName
      identityType
      identityValue
      addresses {
        edges {
          node {
            id
            default
            addressType
            addressValue
          }
        }
      }
      client {
        id
        employmentType
        division {
          id
          name
          employer {
            id
            friendlyName
          }
        }
      }
      contacts {
        edges {
          node {
            id
            division {
              id
              name
            }
            employer {
              id
              friendlyName
            }
          }
        }
      }
    }
  `,
  loan: gql`
    fragment Loan on LoanNode {
      id
      loanType
      amount
      balance
      lmsId
      lmsStatus
      instalmentCurrent
      finalInstalmentAt
      repayableCurrent
      repaid
      createdAt
      refreshedAt
      activatedBy {
        id
        firstName
        lastName
      }
      client {
        id
        identity {
          id
          firstName
          lastName
        }
      }
      issuedBy {
        id
        firstName
        lastName
      }
      loanapplication {
        id
      }
    }
  `,
  loanApplication: gql`
    fragment LoanApplication on LoanApplicationNode {
      id
      firstName
      lastName
      identityValue
      addressValue
      employmentType
      cycle
      clientContribution
      employmentCommencedAt
      employerLoansRules
      calltime
      cashAppliedFor
      retailAppliedFor
      consolidationAppliedFor
      cashEligibleFor
      retailEligibleFor
      consolidationEligibleFor
      cashAppliedForEligible
      retailAppliedForEligible
      consolidationAppliedForEligible
      calculations
      stages
      outcome
      outcomeAt
      outcomeNotes
      approverNotes
      issuerNotes
      overrideNotes
      status
      overrideAt
      finalisedAt
      approvedAt
      assignedTo {
        id
        firstName
        lastName
      }
      approvedBy {
        id
        firstName
        lastName
      }
      createdBy {
        id
        firstName
        lastName
        identity {
          id
        }
      }
      finalisedBy {
        id
        firstName
        lastName
      }
      issuedBy {
        id
        firstName
        lastName
      }
      overrideBy {
        id
        firstName
        lastName
      }
      bankaccount {
        id
        bankName
        accountNumber
        accountType
        branchCode
      }
      client {
        id
        division {
          id
        }
        employmentType
        employmentCommencedAt
        latestInvestmentValue
        identity {
          id
          firstName
          lastName
          identityValue
          identityType
          communicateThrough {
            id
          }
          identitybankaccounts {
            edges {
              node {
                id
                default
                bankaccount {
                  id
                  bankName
                  accountNumber
                  accountType
                  branchCode
                }
              }
            }
          }
        }
        payrollcycle {
          id
          cycle
        }
        saving {
          id
          clientContribution
        }
        loans(lmsStatus: "active") {
          edges {
            node {
              id
              amount
              balance
              loanType
              lmsStatus
              instalmentCurrent
            }
          }
        }
      }
      consolidations {
        edges {
          node {
            id
            amount
            statementExpiresAt
            creditreportaccount {
              id
              creditreportsupplier {
                id
                name
              }
              balance
              openBalance
            }
          }
        }
      }
      creditreport {
        id
        enquiryId
        purpose
        createdAt
        accounts {
          edges {
            node {
              id
              creditreportsupplier {
                id
                name
              }
              balance
              openBalance
              paymentFreqDesc
              instalment
              overdue
              consolidation {
                edges {
                  node {
                    id
                    amount
                    statementExpiresAt
                    bankaccountRef
                    approvedBy {
                      id
                    }
                    creditreportaccount {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      expenses {
        edges {
          node {
            id
            label
            amount
          }
        }
      }
      payslips {
        edges {
          node {
            id
            basicGross
            totalGross
            totalDeductions
            payday
          }
        }
      }
      loans {
        edges {
          node {
            id
            loanType
            amount
            balance
            instalmentCurrent
            instalmentAgreed
            lmsId
            createdAt
            refreshedAt
            activatedBy {
              id
              firstName
              lastName
            }
            workflowrunProcessing {
              id
              status
              atStep
              createdBy {
                id
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  `,
  loanApplicationListing: gql`
    fragment LoanApplicationListing on LoanApplicationNode {
      id
      status
      client {
        id
        identity {
          id
          firstName
          lastName
        }
      }
      cashAppliedFor
      retailAppliedFor
      consolidationAppliedFor
      createdAt
      assignedTo {
        id
        firstName
        lastName
      }
    }
  `,
  message: gql`
    fragment Message on MessageNode {
      id
      fromAddr
      toAddr
      direction
      content
      createdAt
      scheduledAt
      timestamp
      status
      aatErrorMessage
      messageType
      fromIdentity {
        id
        fullName
        client {
          id
        }
      }
      toIdentity {
        id
        fullName
        identityValue
      }
      channel {
        id
        channelId
        channelType
        outboundAddr
        inboundAddr
      }
    }
  `,
  messageRelation: gql`
    fragment MessageRelation on MessageRelationNode {
      id
      objectId
      message {
        id
      }
      contentType {
        id
      }
    }
  `,
  package: gql`
    fragment Package on PackageNode {
      id
      name
      status
      monthlyFee
      feeDiscount
      billableEmployees
      loans
      loansRules
      loansEmployerUnderwritten
      activeAt
      terminatedAt
      notes
    }
  `,
  payment: gql`
    fragment Payment on PaymentNode {
      id
      paymentType
      product
      payer {
        id
        firstName
        lastName
      }
      amount
      originalAmount
      source
      method
      reference
      state
      status
      createdAt
    }
  `,
  payrollcycle: gql`
    fragment PayrollCycle on PayrollCycleNode {
      id
      name
      cycle
      firstPayrollAt
    }
  `,
  payslip: gql`
    fragment Payslip on PayslipNode {
      id
      basicGross
      totalGross
      totalDeductions
      payday
    }
  `,
  responsibility: gql`
    fragment Responsibility on ResponsibilityNode {
      id
      description
      relatedModel
      relatedId
    }
  `,
  requestRun: gql`
    fragment RequestRun on RequestRunNode {
      id
      isAllocated
      asFileLive
      authorisedAt
      isCaptured
      isRecapturable
      content
      createdAt
      isCancellable
      language
      notes
      origin
      isProcessed
      isProcessing
      processingRequired
      status
      updatedAt
      isValidated
      validatedAt
      validationRequired
      isValidatable
      isInvalidatable
      isAwaitingWorkflowrunInitiation
      version
      assignedTo {
        id
        firstName
        lastName
        fullName
      }
      capturedBy {
        id
        fullName
      }
      createdBy {
        id
        username
        identity {
          id
          fullName
        }
      }
      identity {
        id
        firstName
        lastName
        fullName
        identityValue
        language
        isContact
        client {
          id
          division {
            id
            name
            employer {
              id
              friendlyName
            }
          }
        }
        contacts {
          edges {
            node {
              id
            }
          }
        }
      }
      requesttype {
        id
        authorisationRequired
        allocateTo {
          id
          model
        }
        content
        name
        source
        workflow {
          id
        }
        filetypes {
          edges {
            node {
              id
              asset {
                id
              }
            }
          }
        }
      }
      sources {
        id
        asset
        createdAt
        updatedAt
        url
        filetype {
          id
          multipage
        }
        relations {
          edges {
            node {
              id
              objectId
              contentType {
                id
                model
              }
            }
          }
        }
        children {
          edges {
            node {
              id
              asset
              url
            }
          }
        }
      }
      validatedBy {
        id
        firstName
        lastName
        fullName
      }
      workflowrunProcessing {
        id
        createdAt
        description
        status
        atStep
        workflow {
          id
          name
        }
      }
    }
  `,
  requestType: gql`
    fragment RequestType on RequestTypeNode {
      id
      audience
      content
      name
      workflow {
        id
      }
    }
  `,
  saving: gql`
    fragment Saving on SavingNode {
      id
      clientContribution
      employerContribution
    }
  `,
  me: gql`
    fragment MyInfo on IdentityNode {
      id
      firstName
      lastName
      employee {
        id
        status
      }
      contacts {
        edges {
          node {
            id
            employer {
              id
              friendlyName
            }
          }
        }
      }
    }
  `,
  telegrammessage: gql`
    fragment TelegramMessage on TelegramMessageNode {
      id
      direction
      content
      createdAt
      scheduledAt
      status
      messageType
      fromIdentity {
        id
        fullName
        client {
          id
        }
      }
      toIdentity {
        id
        fullName
        identityValue
      }
      fromTgId
      toTgId
    }
  `,
  // TODO: needs to be deleted when no longer used
  workflowRequest: gql`
    fragment WorkflowRequest on WorkflowRequestNode {
      id
      status
      step {
        id
        stepName
        executionMethod
        responsibility
      }
      nextExecutionStep {
        id
        status
      }
      parameters
      assignedTo {
        id
        firstName
        lastName
      }
      scheduledAt
      updatedAt
    }
  `,
  workflowRun: gql`
    fragment WorkflowRun on WorkflowRunNode {
      id
      status
      version
      description
      createdAt
      scheduledAt
      workflow {
        id
        name
      }
    }
  `,
  workflowRunStep: gql`
    fragment WorkflowRunStep on WorkflowRunStepNode {
      id
      status
      description
      assignedTo {
        id
        firstName
        lastName
      }
      parameters
      createdAt
      scheduledAt
      updatedAt
      workflowrun {
        id
        atStep
        description
        requestruns {
          edges {
            node {
              id
            }
          }
        }
        workflow {
          id
          name
        }
      }
      workflowstep {
        id
        name
        number
        executionMethod
        responsibility
      }
      nextWorkflowrunstep {
        id
      }
    }
  `,
}

export default fragments



// WEBPACK FOOTER //
// ./src/fragments.js